<template>
    <div class="footer" ref="footer">
        <div class="menu" v-if="!isPc&&title!='中富金石-首页'">
            <div class="itm" @click="goPage(item)" v-for="item in MenuList">{{item.columnName}}</div>
        </div>
        <div class="wd">
            <div class="title">风险提示</div>
            <div class="tip">{{content.riskTips}}</div>
            <div class="title">合作伙伴</div>
            <div class="imgs">
                <img src="../assets/imgs/js.png" alt="">
                <img src="../assets/imgs/gg.png" alt="">
                <img src="../assets/imgs/sg.png" alt="">
                <img src="../assets/imgs/xl.png" alt="">
                <!-- <img src="../assets/imgs/bd.png" alt=""> -->
                <img src="../assets/imgs/360.png" alt="">
            </div>
            <div class="address">
                <div class="lf">
                    <div class="tp">
                        北京中富金石咨询有限公司（总部）
                    </div>
                    <div class="bm">北京市朝阳区东大桥路8号院1号楼尚都国际中心A座10层1111室/16层1909室</div>
                    <div class="bm"> 电话:010-58701668 邮箱:service@zx017.com </div>
                    <div class="bm1 bm">©2003-2025 zx017.com All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn/">京ICP备11012599号-2</a></div>
                </div>
                <div class="ri">
                    <div class="tp">
                        北京中富金石咨询有限公司四川分公司
                    </div>
                    <div class="bm"> 地址:中国(四川)自由贸易试验区成都高新区天府大道中段801号5幢3层</div>
                    <div class="bm">电话:028-68517888 邮箱:service@zx017.com</div>
                    <div class="bm">©2003-2025 zx017.com All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn/">京ICP备11012599号-2</a></div>
                </div>
            </div>
            <div class="ts">
                <div class="img"><img src="../assets/imgs/occ.png" alt=""></div>
                <div class="img"><img src="../assets/imgs/hlw.png" alt=""></div>
                <div class="img"><img src="../assets/imgs/j.png" alt=""></div>
                <div class="img"><img src="../assets/imgs/3601.png" alt=""></div>
                <div class="img"><img src="../assets/imgs/tz.png" alt=""></div>
                <div class="img"><img src="../assets/imgs/ga.png" alt=""></div>
            </div>
        </div>
        <div class="btm">
            <div style="cursor: pointer;" @click="goPage1(item.url)" v-for="(item,index) in content.quickEntry"
                :key="index">{{item.name}}</div>
        </div>
    </div>
</template>
<script>
import { getMenu } from "../api/index"
import { getFooter } from "../api/index.js"
export default {
    name: 'navFooter',
    data() {
        return {
            lastMenu: [],
            content: {},
            title: "",
            isPc: 1,
            MenuList: ["企业简介", "企业动态", "联系我们", "投资者保护", "终端下载", "信息公示"],
        }
    },
    watch: {
        '$store.state.isPc'(newVal, oldVal) {
            this.isPc = newVal
        },
        $route: {
            handler() {
                this.query = this.$route.query;
                if (this.$route.path != "/contact" && this.$route.path != "/protect") {
                    location.reload()
                }

            },
            deep: true,
        },
    },
    created() {
        this.title = this.$route.meta.title
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone", "iPod"];
        var isPc = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                isPc = false;
                break;
            }
        }
        if (isPc) {
            this.isPc = 1
            this.$store.commit('setIspc', 1)

        } else {
            this.isPc = 0
            this.$store.commit('setIspc', 0)


        }
        this.getMenus()
        this.getFooter()
    },
    mounted() {
        this.$nextTick(() => {
            var hg = window.getComputedStyle(this.$refs.footer).height
            this.$store.commit('setBheight', hg)
        })


    },
    methods: {
        getMenus() {
            if (this.$store.state.menuList.length == 0) {
                // 获取菜单
                getMenu().then((res) => {
                    var now = res.rows
                    now.forEach((item, index) => {
                        if (this.$route.path == item.url) {
                            this.navIdx = index
                        }
                    });
                    this.MenuList = now
                    this.lastMenu = now[now.length - 1]
                    // console.log(this.MenuList)
                    this.$store.commit("setMenu", now)

                }).catch(err => {
                    console.log(err)
                })

            } else {
                this.MenuList = this.$store.state.menuList
                this.MenuList.forEach((item, index) => {
                    if (this.$route.path == item.url) {
                        this.navIdx = index
                    }
                });
                this.lastMenu = this.MenuList[this.MenuList.length - 1]
            }
        },
        getFooter() {
            if (this.$store.state.footer.riskTips) {
                this.content = this.$store.state.footer
            } else {
                getFooter().then(res => {
                    res.data.quickEntry = JSON.parse(res.data.quickEntry)
                    var newl = res.data.quickEntry.filter((item) => {
                        return item.name != null
                    })
                    res.data.quickEntry = newl
                    this.content = res.data
                    this.$store.commit("setFooter", res.data)
                    // console.log(this.$store.state.footer)
                }).catch(err => {
                    console.log(err)
                })
            }

        },
        goPage1(item) {
            if (this.$route.path == item) {
                location.reload()
                return
            }
            this.$router.push(item)
        },
        // 跳转
        goPage(item) {
            if (this.$route.path == item.url) {
                location.reload()
                return
            }
            this.$router.push({ path: item.url })
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.menu {
    background: #F6F8F7;
    margin-bottom: 1.74rem;

    .itm {
        padding: 0.2rem 0.32rem;
        border-bottom: 0.02rem solid rgba(0, 0, 0, 0.1);
        font-size: 0.3rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
    }
}

.wd {
    width: 15.9rem;
    margin: 0 auto;
}

.title {
    font-size: 0.24rem;
    margin-bottom: 0.24rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
}

.tip {
    font-size: 0.24rem;
    color: #808080;
    margin-bottom: 0.6rem;
}

.imgs {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.6rem;

    img {
        width: 1.92rem;
        height: 0.36rem;
    }
}

.address {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;

    .tp {
        font-size: 0.24rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        margin-bottom: 0.16rem;
    }

    .bm {
        max-width: 7.1rem;
        font-size: 0.24rem;
        color: #808080;
        margin-bottom: 0.16rem;
    }
}

.ts {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.99rem;

    a {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
    }

    .img {
        height: 0.8rem;
    }

    .img:nth-child(1) {
        width: 1.53rem;
    }

    .img:nth-child(2) {
        width: 1.62rem;
    }

    .img:nth-child(3) {
        width: 0.75rem;
    }

    .img:nth-child(4) {
        width: 1.7rem;
    }

    .img:nth-child(5) {
        width: 2.49rem;
    }

    .img:nth-child(6) {
        width: 3.66rem;
    }

    .img>img {
        display: block;
        width: 100%;
        height: 100%;
    }
}

.btm {
    height: 1.05rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #2947A9;
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
}

@media (max-width:500px) {
    .wd {
        width: 100%;
        padding: 0 0.32rem;
    }

    .title {
        font-size: 0.32rem;
        margin-bottom: 0.32rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .tip {
        font-size: 0.3rem;
        color: #808080;
        margin-bottom: 0.8rem;
    }

    .imgs {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        flex-wrap: wrap;

        img {
            width: 1.8rem;
            height: 0.32rem;
            margin-bottom: 0.32rem;
        }
    }

    .address {
        margin-bottom: 0.34rem;
        display: block;

        .tp {
            font-size: 0.32rem;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            margin-bottom: 0.12rem;
        }

        .bm {
            font-size: 0.3rem;
            color: #808080;
            margin-bottom: 0.16rem;
        }

        .bm1 {
            margin-bottom: 0.48rem;
        }
    }

    .ts {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 0.4rem;

        a {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
        }

        img {
            height: 0.8rem;
        }

        .img:nth-child(1) {
            width: 1.53rem;
        }

        .img:nth-child(2) {
            width: 1.62rem;
        }

        .img:nth-child(3) {
            width: 0.75rem;
        }

        .img:nth-child(4) {
            width: 1.67rem;
        }

        .img:nth-child(5) {
            width: 2.49rem;
        }

        .img:nth-child(6) {
            width: 3.66rem;
        }
    }

    .btm {
        height: 0.8rem;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: #2947A9;
        font-size: 0.24rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue